// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderClearinghousePayer,
    ProviderClearinghousePayerSortType,
    SupportClearinghousePayer,
    SupportClearinghousePayerSortType,
    SupportCreateClearinghousePayerPayload,
    SupportReplaceClearinghousePayerPayload,
    SupportUpdateClearinghousePayerPayload,
    SupportCreateClearinghousePayerPayloadToJSON,
    SupportReplaceClearinghousePayerPayloadToJSON,
    SupportUpdateClearinghousePayerPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderClearinghousePayerFromJSON,
    SupportClearinghousePayerFromJSON,
} from '../models';

export interface CreateSupportClearinghousePayerRequest {
    supportCreateClearinghousePayerPayload: SupportCreateClearinghousePayerPayload;
}

export interface DisableSupportClearinghousePayerRequest {
    id: string;
}

export interface GetProviderClearinghousePayerRequest {
    id: string;
}

export interface GetSupportClearinghousePayerRequest {
    id: string;
}

export interface ListProviderClearinghousePayersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClearinghousePayersOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPayerName?: Array<string>;
    sort?: Array<ProviderClearinghousePayerSortType>;
}

export interface ListSupportClearinghousePayersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClearinghousePayersOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterActive?: string;
    filterExternalId?: Array<string>;
    filterClearinghouseId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPayerName?: Array<string>;
    sort?: Array<SupportClearinghousePayerSortType>;
}

export interface ReplaceSupportClearinghousePayerRequest {
    supportReplaceClearinghousePayerPayload: SupportReplaceClearinghousePayerPayload;
}

export interface UpdateSupportClearinghousePayerRequest {
    id: string;
    supportUpdateClearinghousePayerPayload: SupportUpdateClearinghousePayerPayload;
}

/**
 * no description
 */
export class ClearinghousePayerApi extends runtime.BaseAPI {

    /**
     * Create clearinghouse payer
     * Create clearinghouse payer
     */
    async createSupportClearinghousePayerRaw(requestParameters: CreateSupportClearinghousePayerRequest): Promise<runtime.ApiResponse<SupportClearinghousePayer>> {
        if (requestParameters['supportCreateClearinghousePayerPayload'] === null || requestParameters['supportCreateClearinghousePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClearinghousePayerPayload','Required parameter requestParameters.supportCreateClearinghousePayerPayload was null or undefined when calling createSupportClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghousepayer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClearinghousePayerPayloadToJSON(requestParameters['supportCreateClearinghousePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghousePayerFromJSON(jsonValue));
    }

    /**
     * Create clearinghouse payer
     * Create clearinghouse payer
     */
    async createSupportClearinghousePayer(requestParameters: CreateSupportClearinghousePayerRequest): Promise<SupportClearinghousePayer> {
        const response = await this.createSupportClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a clearinghouse payer
     * Disable a clearinghouse payer
     */
    async disableSupportClearinghousePayerRaw(requestParameters: DisableSupportClearinghousePayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:clearinghousepayer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a clearinghouse payer
     * Disable a clearinghouse payer
     */
    async disableSupportClearinghousePayer(requestParameters: DisableSupportClearinghousePayerRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse payer
     * Gets a clearinghouse payer
     */
    async getProviderClearinghousePayerRaw(requestParameters: GetProviderClearinghousePayerRequest): Promise<runtime.ApiResponse<ProviderClearinghousePayer>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghousepayer"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghousepayer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClearinghousePayerFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse payer
     * Gets a clearinghouse payer
     */
    async getProviderClearinghousePayer(requestParameters: GetProviderClearinghousePayerRequest): Promise<ProviderClearinghousePayer> {
        const response = await this.getProviderClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse payer
     * Gets a clearinghouse payer
     */
    async getSupportClearinghousePayerRaw(requestParameters: GetSupportClearinghousePayerRequest): Promise<runtime.ApiResponse<SupportClearinghousePayer>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghousepayer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghousePayerFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse payer
     * Gets a clearinghouse payer
     */
    async getSupportClearinghousePayer(requestParameters: GetSupportClearinghousePayerRequest): Promise<SupportClearinghousePayer> {
        const response = await this.getSupportClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * List clearinghouse payers
     * List clearinghouse payers
     */
    async listProviderClearinghousePayersRaw(requestParameters: ListProviderClearinghousePayersRequest): Promise<runtime.ApiResponse<Array<ProviderClearinghousePayer>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPayerName) {
            queryParameters['filterPayerName'] = requestParameters.filterPayerName;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghousepayer"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghousepayer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClearinghousePayerFromJSON));
    }

    /**
     * List clearinghouse payers
     * List clearinghouse payers
     */
    async listProviderClearinghousePayers(requestParameters: ListProviderClearinghousePayersRequest): Promise<Array<ProviderClearinghousePayer>> {
        const response = await this.listProviderClearinghousePayersRaw(requestParameters);
        return await response.value();
    }

    /**
     * List clearinghouse
     * List clearinghouse payers
     */
    async listSupportClearinghousePayersRaw(requestParameters: ListSupportClearinghousePayersRequest): Promise<runtime.ApiResponse<Array<SupportClearinghousePayer>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPayerName) {
            queryParameters['filterPayerName'] = requestParameters.filterPayerName;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghousepayer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClearinghousePayerFromJSON));
    }

    /**
     * List clearinghouse
     * List clearinghouse payers
     */
    async listSupportClearinghousePayers(requestParameters: ListSupportClearinghousePayersRequest): Promise<Array<SupportClearinghousePayer>> {
        const response = await this.listSupportClearinghousePayersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a clearinghouse payer
     * Replace a clearinghouse payer
     */
    async replaceSupportClearinghousePayerRaw(requestParameters: ReplaceSupportClearinghousePayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceClearinghousePayerPayload'] === null || requestParameters['supportReplaceClearinghousePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceClearinghousePayerPayload','Required parameter requestParameters.supportReplaceClearinghousePayerPayload was null or undefined when calling replaceSupportClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghousepayer", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceClearinghousePayerPayloadToJSON(requestParameters['supportReplaceClearinghousePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a clearinghouse payer
     * Replace a clearinghouse payer
     */
    async replaceSupportClearinghousePayer(requestParameters: ReplaceSupportClearinghousePayerRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates a clearinghouse payer
     * Updates a clearinghouse payer
     */
    async updateSupportClearinghousePayerRaw(requestParameters: UpdateSupportClearinghousePayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportClearinghousePayer.');
        }

        if (requestParameters['supportUpdateClearinghousePayerPayload'] === null || requestParameters['supportUpdateClearinghousePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateClearinghousePayerPayload','Required parameter requestParameters.supportUpdateClearinghousePayerPayload was null or undefined when calling updateSupportClearinghousePayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghousepayer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateClearinghousePayerPayloadToJSON(requestParameters['supportUpdateClearinghousePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Updates a clearinghouse payer
     * Updates a clearinghouse payer
     */
    async updateSupportClearinghousePayer(requestParameters: UpdateSupportClearinghousePayerRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportClearinghousePayerRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClearinghousePayersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClearinghousePayersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
